(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3564],{

/***/ 26351:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journal",
      function () {
        return __webpack_require__(76796);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_PageViewAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68971);
/* harmony import */ var _components_UI_GridList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45336);
/* harmony import */ var _components_UI_GridListNav__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64191);
/* harmony import */ var _components_UI_HeroGridList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49035);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28443);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);







function BlogListPage(param) {
    var hero = param.hero, grid = param.grid;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().BlogListPage),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                        children: [
                            hero && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_HeroGridList__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, hero)),
                            grid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_GridList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                hasReadMore: true,
                                hasPagination: true
                            }, grid))
                        ]
                    }),
                    (hero === null || hero === void 0 ? void 0 : hero.links) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_GridListNav__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stickyNav),
                        links: hero === null || hero === void 0 ? void 0 : hero.links
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageViewAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .PageViewAnalytics */ .W, {
                template: "blog"
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogListPage);


/***/ }),

/***/ 28443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BlogArticlePage":"styles_BlogArticlePage___hnjU","BlogListPage":"styles_BlogListPage__PP5Qp","stickyNav":"styles_stickyNav__YABd_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,5019,9774,2888,179], function() { return __webpack_exec__(26351); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);